// Composition-root injection (contract 03 §8, ledger A1). `app/bootstrap.ts` calls
// configureHttp EXACTLY ONCE after Pinia/i18n are ready — wiring the token accessor, the
// unauthorized/logout handler, the global toast and the abort registry. This is the seam
// that lets `shared/http` stay free of `features/*`: http reads these injected functions,
// it never imports the store, router, auth flow or toast.
import type { HttpDeps } from './types'

let deps: HttpDeps | null = null

/** Wire the injected dependencies. Idempotent — a later call replaces the wiring. */
export function configureHttp(next: HttpDeps): void {
  deps = next
}

/** Read the injected deps (null before configureHttp — the client degrades safely). */
export function getHttpDeps(): HttpDeps | null {
  return deps
}

/** Test-only reset of the module-level wiring. Not part of the public barrel. */
export function resetHttpDeps(): void {
  deps = null
}
